module.exports = __webpack_public_path__ + "static/footer-city-b459ccd46ddd19a5a541b07157f4bc3d.svg";